// Unisce i suggerimenti dell'AI alle scelte gia' fatte a mano, senza mai sovrascriverle.
// selected: [{category_id, category_name, section_ids}]; doubts: {category_id: testo}
export const mergeSuggestions = (selected, doubts, suggestions) => {
  const chosen = new Set(selected.map((s) => s.category_id));
  const nextSelected = [...selected];
  const nextDoubts = { ...doubts };
  let filled = 0;
  (suggestions || []).forEach((s) => {
    if (chosen.has(s.category_id)) return; // scelta a mano: resta com'e'
    if (s.section_ids?.length) {
      nextSelected.push({
        category_id: s.category_id,
        category_name: s.name,
        section_ids: [...s.section_ids],
      });
      filled += 1;
    }
    if (s.doubt) nextDoubts[s.category_id] = s.doubt;
    else delete nextDoubts[s.category_id];
  });
  return { selected: nextSelected, doubts: nextDoubts, filled, doubtful: Object.keys(nextDoubts).length };
};
